import { action, makeAutoObservable, observable } from "mobx";

export class VoterReachOutStore {
    messageType: string = "";
    isLoading: boolean = false;
    isSideOverlayOpen: boolean = false;
    isEditOverlayOpen: boolean = false;
    isWhatsappOverviewOpen: boolean = false;
    isMessageOverviewOpen: boolean = false;
    addCampaign: boolean = false;
    editCampaign: boolean = false;
    textMessageFormValue = {
        name: "",
        message: "",
        id: "",
    };
    TargetFormValue = {
        name: "",
        text: "",
        id: "",
    };
    voiceMessageFormValue = {
        name: "",
        id: "",
        message: "",
        attachements: [],
    };
    whatsappMessageFormValue = {
        name: "",
        message: "",
        id: "",
        attachements: [],
    };

    formType: string = "new";

    reachOutList = [];
    reachOutTargetList = [];
    reachOutCampaignList = [];
    selectedOverViewItem = null;
    messageSearchKeyword: string = "";
    targetSearchKeyword: string = "";

    rootStore: any;

    constructor(rootStore: any) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }
    @action
    setTargetSearchKeyword = (keyword: string) => {
        this.targetSearchKeyword = keyword;
    };
    @action
    setMessageSearchKeyword = (keyword: string) => {
        this.messageSearchKeyword = keyword;
    };
    get filteredReachoutTargetList() {
        // Return full list if search is empty
        if (this.targetSearchKeyword === "") return this.reachOutTargetList;

        const searchLower = this.targetSearchKeyword.toLowerCase().trim();

        return this.reachOutTargetList.filter((item) => {
            // Safe access to the name property
            const name = (item?.name as string) || "";

            return name.toLowerCase().trim().includes(searchLower);
        });
    }
    get filteredReachoutList() {
        if (this.messageSearchKeyword === "") return this.reachOutList;

        return this.reachOutList.filter((item) =>
            (item?.ds?.name as string)
                .toLowerCase()
                .trim()
                .includes(this.messageSearchKeyword.toLowerCase().trim())
        );
    }
    @action
    set_messageType(type) {
        this.messageType = type;
    }

    @action
    set_IsWhatsappOverviewOpen(type) {
        this.isWhatsappOverviewOpen = type;
    }

    @action
    set_IsMessageOverviewOpen(type) {
        this.isMessageOverviewOpen = type;
    }

    @action
    set_isSideOverlay(val) {
        this.isSideOverlayOpen = val;
    }

    set_isEditOverlay(val) {
        this.isEditOverlayOpen = val;
    }

    @action
    setEditCampaignStatus = (val) => {
        this.editCampaign = val;
    };

    @action
    setAddCampaignStatus = (val) => {
        this.addCampaign = val;
    };

    @action
    set_formType(val) {
        this.formType = val;
    }

    @action
    set_TargetFormValue(val) {
        this.TargetFormValue = val;
    }

    @action
    set_selected_overview_item(val) {
        this.selectedOverViewItem = val;
    }

    @action
    set_selected_edited_item(val) {
        this.TargetFormValue = {
            name: val.name,
            text: val.text || val.message || val.content || val.msg?.text || "",
            id: val.id,
        };
    }

    @action
    set_textMessageFormValue(formVal) {
        this.textMessageFormValue = {
            name: formVal.name,
            message: formVal.text,
            id: formVal.id,
        };
    }

    @action set_voiceMessageFormValue(formVal) {
        console.log("got here", formVal);
        this.voiceMessageFormValue = {
            name: formVal.name,
            id: formVal.id,
            message: formVal.text,
            attachements: formVal.attachements,
        };
    }

    @action
    set_whatsappMessageFormValue(formVal) {
        console.log("got here", formVal);

        this.whatsappMessageFormValue = {
            name: formVal.name,
            message: formVal.text,
            id: formVal.id,
            attachements: formVal.attachements,
        };
    }

    @action
    reset_TargetFormVal() {
        this.TargetFormValue = {
            name: "",
            text: "",
            id: "",
        };
    }

    @action
    reset_textMessageFormVal() {
        this.textMessageFormValue = {
            name: "",
            message: "",
            id: "",
        };
    }

    @action
    reset_voiceMessageFormVal() {
        this.voiceMessageFormValue = {
            name: "",
            id: "",
            message: "",
            attachements: [],
        };
    }

    @action
    reset_whatsappMessageFormVal() {
        this.whatsappMessageFormValue = {
            name: "",
            message: "",
            attachements: [],
            id: "",
        };
    }

    /**
     * Note: The infinite loop is likely caused by setting this.isLoading or list arrays
     * in a React MobX observer component without using an appropriate reaction/dispose pattern.
     * In components, avoid calling fetch methods directly in the main body or in useEffect
     * without the correct dependency array.
     *
     * To break the loop, do not change observable state on every render.
     * The code below is safe, but callers (components) should use useEffect
     * with proper dependencies (such as [projectid]), NOT on every render.
     *
     * For additional guard, prevent re-triggering if the same payload is used.
     */

    // Payload caches to prevent infinite loops
    lastReachOutMessagePayload = null;
    lastReachOutTargetPayload = null;
    lastReachOutCampaignPayload = null;

    /**
     * Generic API call method to reduce duplication
     * @param endpoint - API endpoint
     * @param payload - Request payload
     * @param onSuccess - Optional callback to handle successful response
     */
    @action
    async _apiCall(endpoint, payload, onSuccess = null) {
        this.isLoading = true;
        try {
            const result = await this.rootStore.api.post(endpoint, payload);
            if (onSuccess) {
                onSuccess(result);
            }
            this.isLoading = false;
            return result;
        } catch (e) {
            this.isLoading = false;
            throw e;
        }
    }

    /**
     * Generic fetch method with payload caching to prevent infinite loops
     * @param endpoint - API endpoint
     * @param payload - Request payload
     * @param cacheKey - Key to store the last payload (e.g., 'lastReachOutMessagePayload')
     * @param onSuccess - Callback to handle successful response
     */
    @action
    async _fetchWithCache(endpoint, payload, cacheKey, onSuccess, refetch) {
        const lastPayload = this[cacheKey];

        // Prevent fetching if the payload hasn't changed
        if (
            JSON.stringify(lastPayload) === JSON.stringify(payload) &&
            !refetch
        ) {
            // Already fetched with this payload; don't refetch to prevent infinite loops
            return;
        }

        // Update cache
        this[cacheKey] = JSON.parse(JSON.stringify(payload));

        return await this._apiCall(endpoint, payload, onSuccess);
    }

    @action
    async get_reachout_message(payload, refetch = false) {
        return await this._fetchWithCache(
            "/reachout/messagesearch",
            payload,
            "lastReachOutMessagePayload",
            (result) => {
                this.reachOutList = result.data;
            },
            refetch
        );
    }

    @action
    async get_reachout_target(payload) {
        return await this._fetchWithCache(
            "reachout/vrotsearch",
            payload,
            "lastReachOutTargetPayload",
            (result) => {
                this.reachOutTargetList = result.data;
            }
        );
    }

    @action
    async get_reachout_Campaign(payload) {
        return await this._fetchWithCache(
            "reachout/vrocsearch",
            payload,
            "lastReachOutCampaignPayload",
            (result) => {
                this.reachOutCampaignList = result.data;
            }
        );
    }

    @action
    async details_reachout_target(payload) {
        return await this._apiCall(
            "reachout/vrotdetails",
            payload,
            (result) => {
                this.selectedOverViewItem = result.data;
                this.set_selected_edited_item(result.data);
            }
        );
    }

    @action
    async details_reachout_Campaign(payload) {
        return await this._apiCall(
            "reachout/vrocdetails",
            payload,
            (result) => {
                this.selectedOverViewItem = result.data;
                this.set_selected_edited_item(result.data);
            }
        );
    }

    @action
    async create_reachout_target(payload) {
        return await this._apiCall("reachout/vrotcreatestatic", payload);
    }

    @action
    async create_reachout_Campaign(payload) {
        return await this._apiCall("reachout/newvrocampaign", payload);
    }

    @action
    async create_reachout_message(payload) {
        return await this._apiCall("/reachout/messagecreate", payload);
    }

    @action
    async update_reachout_message(payload) {
        return await this._apiCall("/reachout/messageupdate", payload, () => {
            this.formType = "new";
        });
    }

    @action
    async update_reachout_target(payload) {
        return await this._apiCall("/reachout/vrotupdatestatic", payload);
    }

    @action
    async delete_reachout_message(payload) {
        return await this._apiCall("/reachout/messagedelete", payload, () => {
            this.formType = "new";
        });
    }

    @action
    async delete_reachout_target(payload) {
        return await this._apiCall("/reachout/vrotdelete", payload);
    }

    @action
    async delete_reachout_campaign(payload) {
        return await this._apiCall("/reachout/vrocdelete", payload);
    }

    @action
    async get_credit_balance(payload) {
        return await this.rootStore.api.post(
            "reachout/get_vro_balance",
            payload
        );
    }

    @action
    async get_transactions(payload) {
        return await this.rootStore.api.post(
            "reachout/transcation_history",
            payload
        );
    }
}
